import { useEffect } from "react";

function upsertMeta(key, keyValue, content) {
  if (!content) return;
  const selector = `meta[${key}="${keyValue}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(key, keyValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * PageMeta
 * Drop into any page to set <title>, description, OpenGraph, Twitter,
 * canonical and robots meta tags. Render-only side-effect; returns null.
 */
export const PageMeta = ({
  title,
  description,
  keywords,
  ogImage = "https://images.unsplash.com/photo-1568667256549-094345857637?auto=format&fit=crop&w=1200&q=80",
  canonical,
  noindex = false,
  ogType = "website",
}) => {
  useEffect(() => {
    const fullTitle = title ? `${title}` : "Prime Wiki Services — Wikipedia Page Specialists";
    document.title = fullTitle;

    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    upsertMeta("name", "author", "Prime Wiki Services");

    // Open Graph
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:url", typeof window !== "undefined" ? window.location.href : "");
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:site_name", "Prime Wiki Services");

    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);

    // Canonical (explicit if provided, otherwise use current URL)
    const href = canonical || (typeof window !== "undefined" ? window.location.href.split("?")[0] : "");
    upsertLink("canonical", href);
  }, [title, description, keywords, ogImage, canonical, noindex, ogType]);
  return null;
};

export default PageMeta;
